module.exports = __webpack_public_path__ + "img/icon1.1e17a53f.png";